/**
 * defa.collections.Recipients
 * A collection of Recipient models.
 * @version 1.0.0
 */

import { Recipient } from './model-recipient';

export const Recipients = Bb.Collection.extend( {
	model: Recipient,
} );

export default Recipients;